import { useState } from "react";
import arrow from "../assets/icons/arrow.svg";
import { useFAQs } from "../pages/reuseableEffects";

const Accordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const FAQs = useFAQs();

  // const accordionItems = [
  //   { 
  //     title: "Can i direct my donations to a particular area or project?",
  //     content: "Yes, you can direct your donations to a particular area or project. Most fundraising organizations, including Mosquepay, provide options for donors to specify where they would like their contributions to be allocated. This ensures that your donation goes towards the cause or project that matters most to you. You can usually find these options on the donation page or by contacting the organization's support team for more detailed guidance."
  //   },
  //   { 
  //     title: "How do i join the Mosquepay community??",
  //     content: "..."
  //   },
  //   { 
  //       title: "How do i set up automatic donation?",
  //       content: "..."
  //     },
  //     { 
  //       title: "How can i partner with Mosquepay??",
  //       content: "..."
  //     },
    
  // ];

  return (
    <div>
      <p className="mb-4 font-semibold capitalize ubuntu-font">Frequently asked questions</p>
      {FAQs.map((item, index) => (
        <div key={index} className="border-t last:border-b transition-all">
          <div className="flex justify-between py-4 cursor-pointer items-center gap-3 hover:bg-secondaryBackground/50" onClick={() => toggleAccordion(index)}>
            <p className="">{item.faq_question}</p>
            <img src={arrow} alt="" className={`transform ${ openIndex === index ? "rotate-180" : "rotate-0" } transition-transform h-5`}/>
          </div>
          {openIndex === index && (
            <div className="pb-4"> <p className="text-secondary">{item.faq_answer}</p> </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
